import { axios, setToken } from '../utils/axios';

const cacheAPI = {
  getFlushCache() {
    setToken();
    return axios.get(`admin/v1/menus/redis/clearCache`);
  },
};

export { cacheAPI };